export default "__VITE_ASSET__BChLQ7CP__"